// use this transport for "binary" data type
$.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
	// check for conditions and support for blob / arraybuffer response type
	if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
		return {
			// create new XMLHttpRequest
			send: function (headers, callback) {
				// setup all variables
				var xhr = new XMLHttpRequest(),
					url = options.url,
					type = options.type,
					async = options.async || true,
				// blob or arraybuffer. Default is blob
					dataType = options.responseType || "blob",
					data = options.data || null,
					username = options.username || null,
					password = options.password || null;

				xhr.addEventListener('load', function () {
					var data = {};
					data[options.dataType] = xhr.response;
					// make callback and send data
					callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
				});

				xhr.open(type, url, async, username, password);

				// setup custom headers
				for (var i in headers) {
					xhr.setRequestHeader(i, headers[i]);
				}

				xhr.responseType = dataType;
				xhr.send(data);
			},
			abort: function () {
				jqXHR.abort();
			}
		};
	}
});

(function ($) {
	$('form[data-type="makepdf"]').each(function (index) {
		var verifiedPdf = false;
		var isFloating = 

			$(this).on('submit', function () {
			if (typeof console !== "undefined" && console !== null) { console.info("Convert to PDF called - Verified: " + verifiedPdf); }

			var form = $(this);
			var isFloating = form.parent().hasClass("container-download");

			var button = form.find('button[type="submit"]');
			var buttonClose = form.find('button[type="button"]');
			
			var hiddenAlert = button.next("p");
			hiddenAlert.removeClass("pdf-error");
			hiddenAlert.addClass("visually-hidden");
			
			var defaultHtml = button.html();

			if (!verifiedPdf) {
				if (isFloating) {
					button.addClass("button-download--active");
					buttonClose.addClass("button-close--active");
				}
				button.attr("disabled", true);

				var genMsg = "Generating PDF, please wait.";
				button.html("<img src='/assets/img/loader2.svg' role='progressbar' class='icon-loader' aria-busy='true' alt=''> " + genMsg);
				hiddenAlert.text(genMsg);
				
				var ajaxSettings = {
					type: 'POST',
					url: form[0].action,
					dataType:'binary',
					contentType: 'application/x-www-form-urlencoded',
					retries: 6
				};

				var onFail = function (jqXHR, textStatus, errorThrown) {
					if (typeof console !== "undefined" && console !== null) { console.log("PDF Check Fail - " + jqXHR.status + " - Retries: " + ajaxSettings.retries); }

					if (ajaxSettings.retries-- > 0) {
						var timeout = 3000;
						if (jqXHR.status == 429 || jqXHR.status == 503) {
							timeout = 15000;
						}

						setTimeout(function () {
							$.ajax(ajaxSettings)
								.done(onSuccess)
								.fail(onFail);
						}, timeout);
					} else {
						verifiedPdf = false;
						button.html(defaultHtml);

						if (!isFloating) {
							hiddenAlert.addClass("pdf-error");
							hiddenAlert.removeClass("visually-hidden");
						} else {
							var title = button.find('.button-download__title');
							title.text("Error. Please try again.");
						}
						hiddenAlert.text("Error generating the PDF. Please try again in a couple of minutes.");

						button.attr("disabled", false);
						button.removeClass("button-download--active");
						buttonClose.removeClass("button-close--active");
					}
				};

				var onSuccess = function (data, textStatus, jqXhr) {
					if (typeof console !== "undefined" && console !== null) { console.info("PDF Check Success - " + jqXhr.status); }
					verifiedPdf = true;
					if (isFloating) {
						button.html("PDF generated.");
						//button.attr("disabled", false);
					} else {
						button.text("PDF generated.");
					}
					//button.removeClass("button-download--active"); 
					hiddenAlert.text(""); // Browser should alert screenreader to the download.
					var disposition = jqXhr.getResponseHeader("Content-Disposition");
					if (null !== disposition && disposition.indexOf("attachment") !== -1) {
						var headerParts = disposition.split(";");
						var keyValuePairs = {};

						for (var i = 0; i < headerParts.length; i++) {
							var keyValuePair = headerParts[i].trim().split("=");
							var key = keyValuePair[0];
							var value = keyValuePair[1];
							keyValuePairs[key] = value;
						}

						var blob = new Blob([data]);
						if (null != blob && blob instanceof Blob) {
							var link = document.createElement('a');
							link.href = window.URL.createObjectURL(blob);
							link.download = keyValuePairs.filename;
							link.click();
						}
					}
				};

				if (typeof console !== "undefined" && console !== null) { console.log("Begin PDF Conversion Check..."); }
				$.ajax(ajaxSettings)
					.done(onSuccess)
					.fail(onFail);

			}
			return verifiedPdf;
		});
	});
})(jQuery);